export const PORTAL_NAME = 'logo-maker-header-content';
